import React from 'react';
import PureComponent from 'ROOT/src/components/pure';

import sAction from 'sAction';

class DetailViewExportButtons extends PureComponent {
    export = () => {
        const data = this.props.data;
        sAction.downloadDocument({id: data.id, module: data.module, type: 'downloadQuote'});
    };

    print = () => {
        const data = this.props.data;
        sAction.downloadDocument({id: data.id, module: data.module, type: 'downloadDocument'});
    };

    render() {
        return (
            <div className="detailViewActions">
                {this.props.data.module === 'Quotes' ?
                    <div onClick={this.export} className="rounded-button icon-export-records"
                        title={'Export'}/> :
                    <div onClick={this.print} className="rounded-button icon-print-records"
                        title={sAction.translate('LBL_EXPORT_PDF')}/>
                }
            </div>
        );
    }
}

export default DetailViewExportButtons;
